export default __webpack_public_path__ + "static/media/IMG_20210821_175520_511.93864d01.jpg";